import React from 'react';

interface Props {
  initialSubheading?: boolean;
}

const Banner: React.FC<Props> = (props: Props) => (
  <div id="banner" className="bottom-border-content">
    <div className="header">
      <h1 className="everpresent-content__heading">Plaid Pattern</h1>
    </div>
    <p id="intro" className="everpresent-content__subheading">
      {props.initialSubheading
        ? 'This is an example app that outlines an end-to-end integration with Plaid.'
        : "This page shows a user's net worth, spending by category, and allows them to explore account and transactions details for linked items."}
    </p>
  </div>
);

Banner.displayName = 'Banner';

export default Banner;
